import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';
import { getMediaUrl } from '../utils/mediaUrl';

const About = () => {
  const { getContent } = useContent();
  const pageHeader = getContent('about.pageHeader') || {};
  const coreValues = getContent('about.coreValues') || {};
  const missionVision = getContent('about.missionVision') || {};
  const companyStory = getContent('about.companyStory') || {};
  const threeBlocks = getContent('about.threeBlocks') || {};
  const chronologie = getContent('about.chronologie') || {};
  const aboutCta = getContent('about.cta') || {};
  const chronologieStats = chronologie.stats || [];
  const showHistorique =
    chronologie.enabled !== false &&
    ((chronologie.timeline || []).length > 0 ||
      chronologieStats.length > 0 ||
      chronologie.image ||
      (chronologie.intro && chronologie.intro.trim()));

  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header" style={{ position: 'relative', overflow: 'hidden' }}>
        {/* Hero Image Layer */}
        {pageHeader.heroImage && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: 'hidden',
            zIndex: 0
          }}>
            <img
              src={getMediaUrl(pageHeader.heroImage)}
              alt="Hero"
              style={pageHeader.heroImageSettings ? {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: `translate(calc(-50% + ${pageHeader.heroImageSettings.position.x}px), calc(-50% + ${pageHeader.heroImageSettings.position.y}px)) scale(${pageHeader.heroImageSettings.scale})`,
                transformOrigin: 'center center',
                width: 'auto',
                height: 'auto',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: 'none',
                objectFit: 'cover'
              } : {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
        )}
        
        {/* Gradient Overlay - Only if enabled */}
        {pageHeader.overlayEnabled !== false && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: pageHeader.overlayColor || '#58c4dc',
            opacity: pageHeader.overlayOpacity ?? 0.85,
            zIndex: 1
          }}></div>
        )}
        
        {/* Content */}
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="page-header-content">
            <h1>{pageHeader.title || 'À propos de Nous'}</h1>
            <p>{pageHeader.subtitle || 'Découvrez notre mission, nos valeurs et l\'équipe d\'experts qui font de DentoXcellence le leader de la formation dentaire en Algérie'}</p>
          </div>
        </div>
      </section>

      {/* 3 Blocs: Notre Histoire, Notre Vision, Notre Historique */}
      <section className="three-blocks-section" id="three-blocks">
        <div className="container">
          
          {/* Notre Histoire */}
          <div className="about-block histoire-block" id="company-story">
            <div className="block-image-text">
              <div className="block-image">
                {threeBlocks.histoire?.image ? (
                  <img src={getMediaUrl(threeBlocks.histoire.image)} alt={threeBlocks.histoire?.title || 'Notre Histoire'} />
                ) : (
                  <div className="block-image-placeholder">
                  <i className={threeBlocks.histoire?.icon || "fas fa-history"}></i>
                  </div>
                )}
              </div>
              <div className="block-content">
                <div className="block-header">
                <h2>{threeBlocks.histoire?.title || 'Notre Histoire'}</h2>
                <p className="block-subtitle">
                  {threeBlocks.histoire?.subtitle || "L'aventure DentoXcellence : de la vision à la réalité"}
                </p>
              </div>
              <div className="block-body">
                  <p>
                  {threeBlocks.histoire?.intro || companyStory.intro || 'DentoXcellence est né de la vision de révolutionner la formation dentaire en Algérie en apportant les standards internationaux de formation et les technologies les plus avancées.'}
                </p>
                {(threeBlocks.histoire?.highlights || []).length > 0 && (
                  <div className="histoire-two-columns histoire-highlights">
                    {threeBlocks.histoire.highlights.map((item, index) => (
                      <div key={index} className="highlight-item">
                        <span className="highlight-year">{item.year}</span>
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    ))}
                  </div>
                )}
                </div>
              </div>
            </div>
            </div>
            
          {/* Notre Vision */}
          <div className="about-block vision-block" id="mission-vision">
            <div className="block-image-text reverse">
              <div className="block-image">
                {threeBlocks.vision?.image ? (
                  <img src={getMediaUrl(threeBlocks.vision.image)} alt={threeBlocks.vision?.title || 'Notre Vision'} />
                ) : (
                  <div className="block-image-placeholder">
                    <i className={threeBlocks.vision?.icon || "fas fa-eye"}></i>
                  </div>
                )}
              </div>
            <div className="block-content">
              <div className="block-header">
                <h2>{threeBlocks.vision?.title || 'Notre Vision'}</h2>
                <p className="block-subtitle">
                  {threeBlocks.vision?.subtitle || "Vers l'excellence dentaire de demain"}
                </p>
              </div>
              
              <div className="block-body">
                  {(threeBlocks.vision?.ambition?.title || threeBlocks.vision?.ambition?.description) ? (
                    <div className="vision-statement">
                      {threeBlocks.vision?.ambition?.title && (
                        <h3>{threeBlocks.vision.ambition.title}</h3>
                      )}
                      <p>
                        {threeBlocks.vision?.ambition?.description ||
                          threeBlocks.vision?.intro ||
                          missionVision.vision?.description ||
                          'Être le référent incontournable de la formation dentaire avancée en Algérie et dans la région MENA, en offrant des programmes de formation de niveau international qui transforment la pratique dentaire.'}
                      </p>
                    </div>
                  ) : (
                    <p>
                      {threeBlocks.vision?.intro ||
                        missionVision.vision?.description ||
                        'Être le référent incontournable de la formation dentaire avancée en Algérie et dans la région MENA, en offrant des programmes de formation de niveau international qui transforment la pratique dentaire.'}
                    </p>
                  )}
                  {(threeBlocks.vision?.strategicGoals?.goals || []).length > 0 && (
                    <div className="vision-goals">
                      {threeBlocks.vision.strategicGoals.title && (
                        <h4>{threeBlocks.vision.strategicGoals.title}</h4>
                      )}
                      <div className="goals-grid">
                        {threeBlocks.vision.strategicGoals.goals.map((goal, index) => (
                          <div key={index} className="goal-item">
                            {goal.icon && <i className={goal.icon}></i>}
                            <h5>{goal.title}</h5>
                            <p>{goal.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Notre Mission */}
          <div className="about-block mission-block" id="mission">
            <div className="block-image-text">
              <div className="block-image">
                {threeBlocks.mission?.image ? (
                  <img src={getMediaUrl(threeBlocks.mission.image)} alt={threeBlocks.mission?.title || 'Notre Mission'} />
                ) : (
                  <div className="block-image-placeholder">
                    <i className={threeBlocks.mission?.icon || "fas fa-bullseye"}></i>
                  </div>
                )}
              </div>
              <div className="block-content">
                <div className="block-header">
                  <h2>{threeBlocks.mission?.title || 'Notre Mission'}</h2>
                  <p className="block-subtitle">
                    {threeBlocks.mission?.subtitle || "Élever à faire évoluer votre carrière"}
                  </p>
                </div>
                <div className="block-body">
                  <p className="mission-description">
                    {threeBlocks.mission?.intro ||
                      threeBlocks.mission?.description ||
                      'Chez DentoXcellence, nous nous engageons à accompagner chaque professionnel dentaire dans l\'évolution de sa pratique grâce à des formations de pointe, des technologies avancées et un accompagnement personnalisé.'}
                  </p>
                  {(threeBlocks.mission?.pillars?.items || []).length > 0 && (
                    <div className="mission-pillars">
                      {threeBlocks.mission.pillars.title && (
                        <h4>{threeBlocks.mission.pillars.title}</h4>
                      )}
                      <div className="pillars-grid">
                        {threeBlocks.mission.pillars.items.map((pillar, index) => (
                          <div key={index} className="pillar-item">
                            {pillar.icon && <i className={pillar.icon}></i>}
                            <h5>{pillar.title}</h5>
                            <p>{pillar.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

                </div>
      </section>

      {/* Nos Valeurs Fondamentales - MOVED HERE */}
      <section className="core-values" id="core-values">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{coreValues.title || 'Nos Valeurs Fondamentales'}</h2>
            <p className="section-subtitle">{coreValues.subtitle || 'Les principes qui guident notre excellence en formation dentaire'}</p>
            </div>
          <div className="values-grid-full">
            {(coreValues.values || []).map((value, index) => (
              <div key={index} className="value-item">
                <div className="value-icon">
                  {value.iconImage ? (
                    <img src={value.iconImage} alt={value.title} className="value-icon-image" />
                  ) : (
                    <i className={value.icon}></i>
                  )}
                </div>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Notre Historique — hidden when disabled or empty in CMS */}
      {showHistorique && (
      <section className="historique-section" id="historique" style={{ position: 'relative' }}>
        <span id="chronologie" style={{ position: 'absolute', left: 0, top: 0, width: 1, height: 1, overflow: 'hidden', pointerEvents: 'none' }} aria-hidden="true" />
        <div className="container">
          <div className="about-block historique-block">
            <div className="historique-centered-layout">
              <div className="block-header centered">
                <h2>{chronologie.title || 'Notre Historique'}</h2>
                <p className="block-subtitle">
              {chronologie.subtitle || 'Parcourez l\'évolution de DentoXcellence à travers les années'}
            </p>
          </div>
          
              <div className="historique-image-center">
                {chronologie?.image ? (
                  <img src={getMediaUrl(chronologie.image)} alt={chronologie?.title || 'Notre Historique'} />
                ) : (
                  <div className="historique-image-placeholder">
                    <i className="fas fa-clock"></i>
                </div>
                )}
              </div>

              <p className="historique-intro centered">
                {chronologie.intro || 'De nos débuts modestes à notre position actuelle de leader en formation dentaire, découvrez les moments clés qui ont façonné DentoXcellence.'}
              </p>
              
              <div className="historique-two-columns">
                {(chronologie.timeline || []).map((item, index) => (
                  <div
                    key={index}
                    className={`summary-item${item.current ? ' summary-item-current' : ''}`}
                  >
                    <span className="summary-year">{item.year}</span>
                    <h4>{item.title}</h4>
                    <p>{item.summary}</p>
                    {(item.details || []).length > 0 && (
                      <ul className="summary-details">
                        {item.details.map((detail, detailIndex) => (
                          <li key={detailIndex}>
                            <i className="fas fa-check-circle" aria-hidden="true"></i>
                            {detail}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>

              {chronologieStats.length > 0 && (
                <div className="chronologie-stats historique-stats">
                  {chronologieStats.map((stat, index) => (
                    <div key={index} className="stat-item">
                      <span className="stat-number">{stat.number}</span>
                      <span className="stat-label">{stat.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      )}

      {/* Call to Action */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>{aboutCta.title || 'Prêt à Transformer Votre Pratique ?'}</h2>
            <p>{aboutCta.subtitle || 'Rejoignez plus de 500 dentistes qui ont fait confiance à DentoXcellence pour leur développement professionnel'}</p>
            <div className="cta-buttons">
              {(aboutCta.buttons || []).map((button, index) => (
                button.link?.startsWith('http') ? (
                  <a key={index}
                     href={button.link} 
                     className={`btn btn-${button.type}`}
                     target="_blank" 
                     rel="noopener noreferrer">
                    <i className={button.icon}></i>
                    {button.text}
                  </a>
                ) : (
                  <Link key={index} to={button.link} className={`btn btn-${button.type}`}>
                    <i className={button.icon}></i>
                    {button.text}
              </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;

